module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.messagesSms.length > 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row",
    attrs: {
      "id": "messages-sms-tab"
    }
  }, [_c('table', {
    staticClass: "table table-responsive sms-table",
    attrs: {
      "id": "users-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Booking Id")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.sms_info.guest_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.sms_info.message_text')))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Total SMS")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.sms_info.to_number')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.sms_info.from_number')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.sms_info.sent_date')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.messagesSms), function(message, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(message.booking_id ? message.booking_id : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.booking && message.booking.guest ? message.booking.guest.first_name + ' ' + message.booking.guest.last_name : '-'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(message.preview))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "col-3 p-l-0 pr-0 d-flex"
    }, [_c('img', {
      staticClass: "mr-15 cursor-pointer preview-message",
      attrs: {
        "src": "/static/assets/images/SuperHote_icons/eye.svg",
        "alt": "NO IMAGE"
      },
      on: {
        "click": function($event) {
          _vm.viewMessage(message.text)
        }
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.sms_sent_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.to_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.from_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("getDateForSmsMessage")(message.created_at)))])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.messagesSms.length == 0) ? _c('div', [_c('div', {
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("account.settings.sms_info.no_sms_found")))])])])]) : _vm._e(), _vm._v(" "), _c('NotificationContent', {
    attrs: {
      "autoActionContent": _vm.message,
      "notificationLoading": false,
      "title": 'Message'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6032eee0"}!./src/app/pages/account/sms-info/index/index.html
// module id = 1402
// module chunks = 0